<button class="btn btn-dark ml-1" (click)="onImportBtn()">
  <i class="fa fa-upload"></i> Import Tickets
</button>

<p-dialog header="Import Run Tickets" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
  <div *ngIf="!fileUploadCompleted || (fileUploadCompleted && !fileUploadSucceeded)">
    <div class="row">
      <div class="col-lg-9 p-text-secondary">
        <p>To import run tickets, copy or enter tickets into our template.</p>
      </div>
      <div class="col-lg-3">
        <button class="btn btn-sm btn-outline-primary" type="button" title="Download template" (click)="downloadTemplate()">
          <span *ngIf="!isDownloadingTemplate"><i class="fas fa-save"></i><span class="px-1"></span>Download template</span>
          <span *ngIf="isDownloadingTemplate"><app-loading-indicator [small]="true"></app-loading-indicator></span>
        </button>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-12">
        <p>Select the completed template from your files.</p>
      </div>
      <div class="col-12">
        <p-fileUpload #fbauto mode="basic" *ngIf="!isUploadingFiles" name="ticketUpload" chooseLabel="Upload" customUpload="true" (uploadHandler)="onUploadFiles($event)" accept=".xls, .xlsx" maxFileSize="1000000" [auto]="true">
        </p-fileUpload>
        <app-loading-indicator *ngIf="isUploadingFiles" [message]="'Uploading and processing file. This may take a few minutes, please do not close this window.'"></app-loading-indicator>
      </div>
    </div>
  </div>

  <div *ngIf="fileUploadCompleted && fileUploadSucceeded" class="py-2">
    <p>The file was uploaded and processed.</p>
    <div class="alert alert-success py-2" *ngIf="failedTickets.length == 0">
      <div class="d-flex justify-content-between align-items-center">
        <span>Run ticket list was successfully imported.</span>
      </div>
    </div>

    <div *ngIf="failedTickets.length && failedTickets.length > 0">
      <div class="alert alert-warning py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Run ticket list was partially imported, please correct the error and try again.</span>
        </div>
      </div>

      <div class="alert alert-danger py-2">
        <div class="d-flex justify-content-between align-items-center">
          <div class="pointer-cursor" role="button" (click)="failedCollapsed = !failedCollapsed">
            <span *ngIf="failedTickets.length == 1">1 run ticket not imported</span>
            <span *ngIf="failedTickets.length > 1">{{failedTickets.length}} run tickets not imported</span>
          </div>
          <button type="button" class="btn" (click)="failedCollapsed = !failedCollapsed" [attr.aria-expanded]="!failedCollapsed" aria-controls="failedCollapseDiv">
            <span *ngIf="failedCollapsed" class="hover-pointer"><i class="fas fa-chevron-down"></i></span>
            <span *ngIf="!failedCollapsed" class="hover-pointer"><i class="fas fa-chevron-up"></i></span>
          </button>
        </div>
        <!--<div id="failedCollapseDiv" [ngbCollapse]="failedCollapsed">
          <table class="table table-sm table-striped rr-table" style="font-size: 0.9em;">
            <thead>
              <tr>
                <th class="text-center">Count</th>
                <th>Date</th>
                <th>Ticket</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ticket of failedTickets; index as i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ ticket.entryDate | date: 'mediumDate' }}</td>
                <td>{{ ticket.ticket }}</td>
                <td>{{ ticket.errorComment }}</td>
              </tr>
            </tbody>
          </table>
        </div>-->
      </div>
    </div>

  </div>
  <div *ngIf="fileUploadCompleted && !fileUploadSucceeded" class="py-2">
    <div class="alert alert-danger">
      {{ fileUploadError }}
    </div>
  </div>

  <div class="justify-content-center">
    <div *ngIf="!fileUploadCompleted || (fileUploadCompleted && !fileUploadSucceeded)" class="d-flex justify-content-center">
      <button class="btn btn-secondary" (click)="visible = false">Cancel</button>
    </div>
    <div *ngIf="fileUploadCompleted && fileUploadSucceeded" class="d-flex justify-content-center">
      <button class="btn btn-secondary" (click)="visible = false">Close</button>
    </div>
  </div>
</p-dialog>
